// @ts-strict-ignore
import { Body } from "components/parts/Typography";
import styled, { css } from "styled-components";

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.contentPadding}px;

  ${({ theme: { media } }) => media.desktop`
    flex-direction: row;
  `}
`;

export const RightContent = styled.div`
  margin: 0;
  padding: 15px 0;
  width: 100%;

  ${({ theme: { media } }) => media.desktop`
    width: 65%;
  `}
`;

export const LeftContent = styled.ul`
  margin: 0;
  padding: 0;
  display: none;
  ${({ theme: { media } }) => media.desktop`
    width: 30%;
    margin-right: 5%;
    display: block;
  `}
`;

export const AnchorLink = styled.a`
  display: inline-block;
  text-decoration: none;
  white-space: break-spaces;
  color: ${({ theme }) => theme.textColors.primary};
  &:visited {
    color: ${({ theme }) => theme.textColors.primary};
  }

  ${(props) =>
    props.isSecondary &&
    css`
      margin-left: 25px;
    `};
`;

export const AnchorLinkContainer = styled.li`
  display: flex;
  align-items: center;
  margin: 16px 0;
  cursor: pointer;
`;

export const FixedContent = styled.div`
  padding: 0;
  margin: 30px 0 0;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 110px;
  ${({ theme: { media } }) => media.tablet`
    margin: 40px 0 0;
  `}
`;

export const CardContent = styled.ul`
  padding: 4px 25px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.backgroundColors.secondary};
  max-height: 510px;
  overflow-y: scroll;
  overflow-x: hidden;
  &:hover {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }

  &::-webkit-scrollbar {
    width: 10px;
    padding-right: 10px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colorPalette.gray["300"]};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colorPalette.gray["400"]};
  }
  ul {
    padding: 0;
  }
`;

export const ArticleContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme: { media } }) => media.tablet`
    margin-top: 24px;
    flex-direction: row;
  `}
  ${({ theme: { media } }) => media.desktop`
    margin-top: 20px;
  `}
`;

export const BackLink = styled(Body).attrs({ size: "md" })`
  margin-bottom: 24px;
  ${({ noDesktop }) => noDesktop && `margin-top: 32px;`}
  ${({ theme }) => theme.media.desktop`
    ${({ noDesktop }) => noDesktop && `display: none;`}
  `}
`;
